import camelCase from 'lodash/camelCase';

export const formatProductForOperation = (product: string) => {
	return camelCase(product);
};

export const getOperationName = (product: string) => {
	return `${formatProductForOperation(product)}_activity_recentWorkClient`;
};
